import Ajaxinate from '../utils/ajaxnate';
import { currentLang } from '../utils/getLanguage';
import { mediaQuery } from '../utils/mediaQuery';
import { $Q, $Qll } from '../utils/querySelector';
import { redirect } from '../utils/redirect';
import { toggleDataActive } from '../utils/toggleDataset';

class Collection {
  constructor() {
    this.toggleMobile();
    this.initCustomPriceFilter();
    this.redirectToCollectionsAll();
  }

  /**
   * Infinite scroll to collections.
   * Use Ajaxinate libreary
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  infiniteScroll() {
    if (document.querySelector('#js-infinite-scroll')) {
      new Ajaxinate({
        container: '#js-infinite-scroll',
        pagination: '#js-infinite-scroll-paginate',
        loadingText: `${this.loaderComponent()}`,
        offset: 3000,
      });
    }
  }

  /**
   * Loader component as a string, to render with JS
   * @returns {NodeString} HTML as a string
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  loaderComponent = () => `
    <div class="loading-overlay collections">
      <div class="loading-overlay__spinner">
        <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="28"></circle>
        </svg>
      </div>
    </div>
  `;

  /**
   * Toggle to filter in the mobiel version.
   * Add media query to call feature.
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  toggleMobile() {
    if ($Q('#js-filter-header')) {
      mediaQuery('(max-width: 991px)', () => {
        toggleDataActive('#js-filter-header-title', '#js-filter-header');
        toggleDataActive(
          '.collection__filters-header-content .icon-close',
          '#js-filter-header'
        );
      });
    }
  }

  /**
   * Init elements and methods of price filter
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  initCustomPriceFilter() {
    if ($Q('#js-price-range')) {
      this.elRangeOne = $Q('#js-range-1');
      this.elRangeTwo = $Q('#js-range-2');
      this.displayValOne = $Qll('.range1');
      this.displayValTwo = $Qll('.range2');
      this.sliderTrack = $Q('.slider-track');
      this.sliderMaxValue = $Q('#js-range-1').max;

      this.updateDisplayPriceFilter(
        this.displayValOne,
        this.elRangeOne.value,
        true
      );
      this.updateDisplayPriceFilter(
        this.displayValTwo,
        this.elRangeTwo.value,
        true
      );

      this.fillColorPriceFilter();
      this.rangeInputPriceFilter();
      this.numInputPriceFilter();
      this.sortBy();
    }
  }

  /**
   * Init events to input range
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  rangeInputPriceFilter() {
    let minGap = 0;
    const validationRangeValue =
      parseInt(this.elRangeTwo.value) - parseInt(this.elRangeOne.value) <=
      minGap;

    this.elRangeOne.addEventListener('input', () => {
      if (validationRangeValue) {
        this.updateDisplayPriceFilter(
          this.displayValOne,
          this.elRangeOne.value
        );
        this.fillColorPriceFilter();
      }

      this.updateDisplayPriceFilter(this.displayValOne, this.elRangeOne.value);
      this.fillColorPriceFilter();
    });
    this.elRangeTwo.addEventListener('input', () => {
      if (validationRangeValue) {
        this.updateDisplayPriceFilter(
          this.displayValTwo,
          this.elRangeTwo.value
        );
        this.fillColorPriceFilter();
      }

      this.updateDisplayPriceFilter(this.displayValTwo, this.elRangeTwo.value);
      this.fillColorPriceFilter();
    });
  }

  /**
   * Listener change in input number to change input range and display
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  numInputPriceFilter() {
    $Q('.range1[type=number]').addEventListener('input', (e) => {
      this.updateDisplayPriceFilter(this.displayValOne, e.target.value);
    });
    $Q('.range2[type=number]').addEventListener('input', (e) => {
      this.updateDisplayPriceFilter(this.displayValTwo, e.target.value);
    });
  }

  /**
   * Update bar input range each time that is change.
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  fillColorPriceFilter() {
    const percent1 = (this.elRangeOne.value / this.sliderMaxValue) * 100;
    const percent2 = (this.elRangeTwo.value / this.sliderMaxValue) * 100;

    this.sliderTrack.style.background = `linear-gradient(to right, #fff ${percent1}% , #231916 ${percent1}% , #231916 ${percent2}%, #fff ${percent2}%)`;
  }

  /**
   * Update component showing price filter in the filter price section
   * @param {Node} el - Element that display price filter number
   * @param {Node} rangeInput - Range input that change
   * @param {Boolean} init - If initialize filter or no for no apply default value
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  updateDisplayPriceFilter(el, rangeInput, init = false) {
    el.forEach((rangeDisplay) => {
      if (init) {
        rangeDisplay.textContent = this.parseCurrency(rangeInput);
        return null;
      }

      if (rangeDisplay.classList.contains('form_textfield')) {
        rangeDisplay.value = rangeInput;
      } else {
        rangeDisplay.textContent = this.parseCurrency(rangeInput);
      }
    });
  }

  /**
   * Format a price
   * @param {Number} price - Number
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  parseCurrency(price) {
    return new window.Intl.NumberFormat(
      `${currentLang ? currentLang.toLowerCase() : 'en'
      }-${currentLang ? currentLang.toUpperCase() : 'EN'
      }`,
      {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
      }
    ).format(price);
  }

  sortBy() {
    $Q('#sort-by-collections') &&
      $Q('#sort-by-collections').addEventListener('change', (e) => {
        window.location.href = e.target.value;
      });
  }

  /**
   * Redirec collections (list) tempate to collections/all template
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  redirectToCollectionsAll() {
    if (window.location.pathname === '/collections') {
      redirect('/collections/all');
    }
  }
}

export { Collection };
